import * as React from "react";
import { Link, ErrorNotification, Margin, P, TextLink } from "@ovotech/element";

export const AlreadyVerifiedPageContent = () => (
  <>
    <ErrorNotification
      id="already-verified-error"
      title="You’ve already confirmed your email address"
      style={{ marginBottom: "4rem" }}
    >
      <P>
        Please check your email for the updates or if you have any questions,
        give us a call on{" "}
        <TextLink href="tel:03303035059">0330 303 5059</TextLink> or email us at{" "}
        <TextLink href="mailto:electricvehicles@ovoenergy.com">
          electricvehicles@ovoenergy.com
        </TextLink>
      </P>
    </ErrorNotification>

    <Margin top={8} />
    <Link
      variant="outline"
      data-testid="back-button"
      href="https://www.ovoenergy.com/"
      target="_self"
    >
      Back to the OVO homepage
    </Link>
  </>
);
